// tslint:disable: jsx-no-multiline-js

import { Icon, INodeData, TreeView } from '@abb/common-ux';
import * as React from 'react';
import './DropdownTreeSelect.scss';

export interface IDropdownTreeSelectOption extends INodeData {
  value: string;
  display: string;
}

interface IDropdownTreeSelectProps {
    readonly name: string;
    readonly labelText?: string;
    readonly placeholder?: string;
    readonly isRequired?: boolean;
    readonly selected?: IDropdownTreeSelectOption;
    readonly options: IDropdownTreeSelectOption[];
    readonly onChange: (selected?: IDropdownTreeSelectOption) => void;
}

interface IDropdownTreeSelectState {
  showTree: boolean;
  expandedNodeIds: string[];
}

export class DropdownTreeSelect extends React.Component<IDropdownTreeSelectProps, IDropdownTreeSelectState> {
  treeSelectRef: any;

  constructor(props: IDropdownTreeSelectProps) {
    super(props);

    this.state = {
      showTree: false,
      expandedNodeIds : []
    };

    this.treeSelectRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('click', this.handleCloseOptions);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleCloseOptions);
  }

  render() { 
    const icon = this.state.showTree ? 'up' : 'down';  
    return (
      <div className='tree-select'>
        <div className='form-group'>
          {this.props.labelText !== undefined
            ? <label className={this.props.isRequired ? 'required-input-label' : ''}>{this.props.labelText}</label>
            : null
          }
          <input 
            name={this.props.name} type='text' className='form-control' 
            autoComplete='off' placeholder={this.props.placeholder ? this.props.placeholder : ''}
            value={this.props.selected ? this.props.selected.display : ''}
            onClick={this.handleToggleOptions}/>
        </div>
        <span className='arrow' onClick={this.handleToggleOptions}><Icon icon={icon} size='small' />{' '}</span>
        {this.state.showTree
          ? <div className='tree-select-menu-outer' ref={this.treeSelectRef}> 
              <TreeView 
                nodes={this.props.options} 
                nodeExpandedCallback={this.handleNodeExpanded} 
                nodeSelectedCallback={this.handleNodeSelected}
                expandedNodeIDs={this.state.expandedNodeIds} 
                selectedNodeIDs={this.props.selected ? [this.props.selected.id] : []}
                />
            </div>
          : null
        }
        </div>
    );
  }

  handleToggleOptions = (e: any) => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState(prevState => ({showTree: !prevState.showTree}));
  }

  handleCloseOptions = (e: any) => {
    if (this.treeSelectRef.current !== null && this.treeSelectRef.current.contains(e.target)) {
      return;
    }
    if (this.state.showTree) {
      this.setState({showTree: false});
    }
  }

  handleNodeExpanded = (node: IDropdownTreeSelectOption) => {
    const expandedNodeIds = this.state.expandedNodeIds;
    const idx = expandedNodeIds.indexOf(node.id);
    idx === -1 ? expandedNodeIds.push(node.id) : expandedNodeIds.splice(idx, 1);
    this.setState({expandedNodeIds});
  }

  handleNodeSelected = (node: IDropdownTreeSelectOption, height: number) => {
    const expandedNodeIds = this.state.expandedNodeIds;
    const idx = expandedNodeIds.indexOf(node.id);

    if (height > 0) {
      idx === -1 ? expandedNodeIds.push(node.id) : expandedNodeIds.splice(idx, 1);
      this.setState({expandedNodeIds});
    } else {
      this.props.selected && this.props.selected.id === node.id ? this.props.onChange() : this.props.onChange(node);
    }
  }
}
